import styled from 'styled-components';

const ListWrapper = styled.ul`
    padding: 0;
    margin:  ${ ( { theme } ) => theme.spacing06 } 0;
    list-style: none;
`;

export default ListWrapper;
